/** Pure CSS floating-particles backdrop. Renders 3 drifting layers via the
 *  `.particles-bg` rules in index.css. No JS animation, no canvas. */
export default function ParticlesBg({ className = "" }) {
    return (
        <div aria-hidden="true" className={`particles-bg ${className}`} data-testid="particles-bg">
            <div className="layer" />
        </div>
    );
}
